import styled from "styled-components";

const StyledLogo = styled.img`
	width: 225px;
	margin: 0 36px;
	height: auto;
`;

export default StyledLogo;
